import React from 'react';
import {useCountdownTo} from '../../../../../../data/hooks/datetimeHooks';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import {useForceUpdate, useInterval} from '../../../../../../misc/hooks';
import styles from '../EventProgramSection.module.scss';

// NOTE: make sure src/components/sidepanel/EventWaitingRoom/common/Time.jsx matches

const CountdownTo = props => {
    const {item} = props,
        i18n = useI18n(),
        {diff, days, hours, minutes, seconds} = useCountdownTo(item.start_utc),
        forceUpdate = useForceUpdate();

    useInterval(forceUpdate, 500);

    if (diff <= 0) return null;

    return (
        <div className={styles.CountdownTo}>
            <span className={styles.label}>{i18n['label.next-session']} </span>
            <span className={styles.time}>
                {hours > 36 && days > 1
                    ? i18n['label.days.future'].replace('{0}', days.toString())
                    : `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`}
            </span>
        </div>
    );
};

export default CountdownTo;
